export default "__VITE_ASSET__uN_21bU9__"